import React from "react";
import * as dayjs from "dayjs";
import { useTranslation } from "../langs/useTranslation";
import { getAlarmTemplatesApi } from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";

export const EnabledAlarmTemplateListDatatable = React.forwardRef(
  ({ className, style, footer, children, onCheckAll, onLoaded }, ref) => {
    const { t } = useTranslation();

    const columns = [
      {
        data: "id",
        type: "checkbox"
      },
      {
        data: "name",
        title: t({ defaultMessage: "报警模板名称" }),
        searchable: true
      },
      {
        data: "policies",
        title: t({ defaultMessage: "报警规则" }),
        width: 200,
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              {data.map((item, index) => (
                <div key={index}>
                  {item.replace("&lt;", " < ").replace("&gt;", " > ")}
                </div>
              ))}
            </>,
            td
          );
        }
      },
      {
        data: "note",
        title: t({ defaultMessage: "注解" })
      },
      {
        data: "create_user.name",
        title: t({ defaultMessage: "创建人" })
      },
      {
        data: "created_at",
        title: t({ defaultMessage: "创建时间" }),
        width: 120,
        searchable: false,
        render: data => {
          return dayjs(data).format("YYYY/MM/DD HH:mm");
        }
      }
    ];

    const ajax = (data, callback, settings) => {
      return getAlarmTemplatesApi({
        status: 1,
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.data,
          draw: data.draw,
          recordsFiltered: res.recordsTotal,
          recordsTotal: res.recordsTotal
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        footer={footer}
        onCheckAll={onCheckAll}
        onLoaded={onLoaded}
        autoLoad
      >
        {children}
      </DataTable>
    );
  }
);
